import React, { Component } from "react";
import { connect } from "./../../../base/redux";
import { Avatar } from '../../../base/avatar';
import AuthHelper from "./../../services/authService";
import { grantModerator, localParticipantRoleChanged, participantRoleChanged } from '../../../base/participants';
import { SendCommandOnce, ToggleChat, _getAllParticipants } from './actions';
import { LockMeeting } from "./../Meet/meet_actions";
import { firebaseDatabase } from "../../services/firebaseService"; 
import Chat from "../../services/Chat"
import './indicator.css';
import { participantUpdated } from '../../../base/participants';
import Picker from 'emoji-picker-react';
import SimpleReactValidator from 'simple-react-validator';
import { InviteViaMail,SentMailList } from './../device-selection/actions';
import __WaitingRoom from "./../../services/Chat"
import { getConferenceNameForTitle } from '../../../base/conference';
import ConnectionIndicator from "../connection-indicator/ConnectionIndicator";
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';  
import { MEDIA_TYPE } from "../../../base/media";
import { getTrackByMediaTypeAndParticipant } from "../../../base/tracks";
import {toggleReactionsMenuVisibility} from "../../../reactions/actions.web"
import ReactionButton from "../../../reactions/components/web/ReactionButton";
import { addReactionToBuffer } from "../../../reactions/actions.any";
import { createReactionMenuEvent, sendAnalytics } from "../../../analytics";
import { REACTIONS } from "../../../reactions/constants";
import { meetingURL } from "../../common";

class InviteMore extends Component {
    constructor(props) {
        super(props);
        this.state = {videoTracks: {}, audioTracks: {},tab: 'home', searchBox: false, searchData: "", isModerator: false, isInvited: false, inviteType: "member", callStatus: {}, host: "", topic: "", totalStatus: {},showEmoji: false, email: "", __invitedNum: [], members: [], clicked: false,email_list:[],member_list:[],toggle_reactions:false };
        this.validator = new SimpleReactValidator();
        this.emailvalidator = new SimpleReactValidator();
    }

    componentDidMount() {        
        $(".invite-modal-body-outer").draggable({
            handle: ".invite-modal-body-inner",
            containment: "#InviteModal",
        });
        this.CallRef = firebaseDatabase.ref("InviteMembers");
        this.CallControl(); 
        const {is_owner} = this.props;
        // if(is_owner){
        //     this.GetMailList();
        // } 
        this.GetMailList();

    }

    GetMailList = async() => {
        let { uniquekey } = this.props;
        let response = await APP.store.dispatch(SentMailList({meeting_code:uniquekey}));
        console.log("GetMailList1",response)
        if(response.code===1){
            this.setState({email_list:response.response});
        }
    }

    

    CheckStatus = () => {
        const __UpdateStatus = __value => {
            if (!__value) {
                return false;
            }
            let totalStatus = {};
            Object.keys(__value).map(__childVal => {
                totalStatus = { ...totalStatus, [__childVal]: __value[__childVal].online };
            })
            this.setState({ totalStatus });
        }
        Chat.fetch_ref_on_update(`status`, __UpdateStatus);
    }

    CallControl = () => {
        this.CallRef.on("value", (snapshot) => {
            let roomID = APP.conference.roomName;
            let newValues = {}
            snapshot.forEach((childSnapshot) => {
                let childval = childSnapshot.val();
                if (childval['roomID'] && childval['roomID'] === roomID) {
                    newValues = { ...newValues, [childval['toNumber']]: childval['status'] };
                    if (childval['status'] === "Connecting") {
                        this.RemoveElement(childval['toNumber']);
                    }
                }
            });
            this.setState({ callStatus: newValues });
        });
    }
 
    RemoveElement = (number) => {
        setTimeout(() => {
            this.CallRef.child(number).get().then((snapshot) => {
                if (snapshot.exists()) {
                    let GetValueStatus = snapshot.val()['status'];
                    if (GetValueStatus === "Connecting") {
                        this.CallRef.child(number).remove();
                    }
                }
            })
        }, 10000);
    }

    DisconnectNumber = (toNumber, statusCheck = false) => {
        this.CallRef.once("value").then((snapshot) => {
            if (snapshot.hasChild(toNumber)) {
                if (statusCheck) {
                    let getVal = snapshot.val();
                    if (getVal[toNumber]?.status && getVal[toNumber].status === "ringing") {
                        this.CallRef.child(toNumber).remove();
                    }
                } else {
                    this.CallRef.child(toNumber).remove();
                }
            }
        });
    }

    MakeCall = (toNumber, fromNumber, roomID, app_picture) => { 
        const { host, topic } = this.state;
        this.CallRef.once("value").then((snapshot) => {
            if (!snapshot.hasChild(toNumber)) {
                let userData = { toNumber, fromNumber, roomID, status: "ringing", host, topic, app_picture }; 
                this.CallRef.child(toNumber).set(userData);
                let myTimeout = setTimeout(() => {
                    this.DisconnectNumber(toNumber, true);
                    clearTimeout(myTimeout);
                }, 20000)
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { isModerator } = this.state;
        const { _participants: old_particpants, tracks: old_tracks} = prevProps; 
        const { _participants, _meetDetail, tracks } = this.props; 
        let ownerID = AuthHelper.getUserDetail()?.customerID ?? 0;
        if (!isModerator && ownerID === _meetDetail.is_owner) {
            this.setState({ isModerator: true, host: _meetDetail.host_name, topic: _meetDetail.topic }); 
            this.CheckStatus();
        }
        if (old_particpants && _participants && old_particpants.length !== _participants.length && ownerID === _meetDetail.is_owner) {
            _participants.map(value => {
                if (value.local && value.role !== "moderator") {
                    APP.store.dispatch(localParticipantRoleChanged('moderator'));
                } else if (value.role !== "member" && value.role !== "coordinator") {
                    APP.store.dispatch(participantRoleChanged(value.id, 'member'));
                }
            })
        }
         
        if (old_tracks && tracks && old_tracks !== tracks) {
            let videoTracks = {};
            let audioTracks = {}; 
            tracks.map(value => {
                if (value.mediaType === "video") {
                    videoTracks = { ...videoTracks, [value.participantId]: value.muted };  
                } 
                if (value.mediaType === "audio") {
                    audioTracks = { ...audioTracks, [value.participantId]: value.muted };
                } 
            }) 
            this.setState({ videoTracks,audioTracks });
        }
    }

    LockUnlockMeet = async () => {
        const { restricted, onUpdateRestriction } = this.props
        let { roomName: room_name } = APP.conference;
        const response = await APP.store.dispatch(LockMeeting({ room_name, locked: restricted ? "N" : "Y" }));
        if (response === 1) {
            onUpdateRestriction();
        }
    }

    InviteMember = (__invitedNum) => { 
        __invitedNum.map(value => {
            let toNumber = value.replace('+', '');
            let phone = (AuthHelper.getUserDetail().phone).replace('+', '');
            let app_picture = AuthHelper.getUserDetail().app_picture ?? "public/assets/images/Image.png";
            let roomID = APP.conference.roomName;
            this.setState({ roomID }, () => {
                this.MakeCall(toNumber, phone, roomID, app_picture);
                alert("Invitation sent successfully to team members.")
            }) 
        })

    }

    SendApproval = (__email, approve) => {
        let { _roomName: __RoomID } = this.props;
        __WaitingRoom.fetch_if_ref_exists(`/WaitingRoom/${__RoomID}/`, true).then(__value => {
            if (__value instanceof Array && __value.length) {
                let __filtered = __value.findIndex(__val => __val.email === __email);
                if (__filtered !== -1) {
                    __value[__filtered] = { ...__value[__filtered], join: approve, approval: approve ? "Y" : "R" }
                    __WaitingRoom.update_ref_with_children(`/WaitingRoom/${__RoomID}/`, __value);
                }
            }
        });
    }

    onRaiseHand = (id) => {
        APP.store.dispatch(participantUpdated({
            id,
            local: false,
            raisedHand: false
        }));
    }

    onEmojiClick = (event, emojiObject) => {
        const { emoji } = emojiObject;
        SendCommandOnce("emoji-shared", JSON.stringify({ participantId: APP.conference.getMyUserId(), emoji }));
    };

    SendEmail = async () => {
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        this.setState({ clicked: true });
        let { members } = this.state;
        let { uniquekey:meeting_code } = this.props;
        let response = await APP.store.dispatch(InviteViaMail({ 
            email:members.map(val=>val.label), 
            meeting_code, link:meetingURL() 
        }));
        if (response === 1) {
            this.GetMailList();
            this.setState({ members: [], clicked: false })
        } else {
            this.setState({ clicked: false})
        }
    }

    RemindEmail = async () => {
        this.setState({ clicked: true });
        let { uniquekey:meeting_code } = this.props;
        let { member_list } = this.state;
        let response = await APP.store.dispatch(InviteViaMail({ 
            email:member_list, 
            meeting_code, 
            link: meetingURL() 
        }));
        if (response === 1) {
            this.setState({ member_list: [], clicked: false })
        } else {
            this.setState({ clicked: false})
        }
    }

    handleDelete = (emailToDelete) => () => {
        const { members } = this.state;
        this.setState({ members: members.filter((response) => response.key !== emailToDelete.key) });
    };

    handleKeyDown = evt => {
        const { members } = this.state;
        if (evt.key === "Backspace" && evt.target.value === "") {
            this.setState({ email: members?.[members.length - 1]?.label ?? "" }, () => {
                members.pop();
                this.setState({ members });
            });
        }
        if (["Enter", "Tab", ","].includes(evt.key)) {
            evt.preventDefault();
            if (!this.emailvalidator.allValid()) {
                this.emailvalidator.showMessages();
                this.forceUpdate();
                return false
            }
            const { email } = this.state;
            var value = email.trim();
            if (value && !this.isInList(value)) {
                this.setState({ members: [...members, { key: members.length, label: value }] })
            }
            this.setState({ email: "" });
        }
    };

    handleChange = evt => {
        this.setState({ email: evt.target.value });
    };

    isInList = (email) => {
        const { members } = this.state;
        return members.filter(list => list.label === email).length;
    } 

    onToggleChat = () => {
        ToggleChat();
        window.$(".right-chat-1").removeClass("d-none")
        window.$("#InviteModal").modal("hide")
    };

    grantModeratorHandler = (data)=>{ 
        APP.store.dispatch(participantRoleChanged (data.id, 'coordinator')); 
        APP.store.dispatch( grantModerator(data.id));
        SendCommandOnce("role-changed", data.id);  
        let { uniquekey } = this.props; 
        let updateParticipants;
        const __UpdateUsers = (users) => {
            if (users?.participants) {
                const { participants } = users;  
                    updateParticipants = participants.map(value => {
                    if (value.id === data.id) {  
                        value["type"] = "coordinator" ;
                        return value
                    }
                    return value;
                }) 
            }
        } 
        Chat.fetch_ref_on_update(`Groups/${uniquekey}`, __UpdateUsers); 
        firebaseDatabase.ref(`Groups/${uniquekey}/participants/`).update(updateParticipants);
    }

    toggleReactionsMenu = ()=>{ 
        const {toggle_reactions } = this.state
        this.setState({
            toggle_reactions:!toggle_reactions
        },()=>{
            APP.store.dispatch(toggleReactionsMenuVisibility());
        }) 
    }

    _getReactionButtons =()=> { 
        let modifierKey = 'Alt';
    
        if (window.navigator?.platform) {
            if (window.navigator.platform.indexOf('Mac') !== -1) {
                modifierKey = '⌥';
            }
        }
    
        return Object.keys(REACTIONS).map(key => {
            /**
             * Sends reaction message.
             *
             * @returns {void}
             */
            function doSendReaction() {
                APP.store.dispatch(addReactionToBuffer(key));
                sendAnalytics(createReactionMenuEvent(key));
            }
    
            return (<ReactionButton
                accessibilityLabel = { `${key}`}
                icon = { REACTIONS[key].emoji }
                key = { key }
                onClick = { doSendReaction }
                toggled = { false }
                tooltip = { `${`${key}`} (${modifierKey} + ${REACTIONS[key].shortcutChar})` } />);
        });
    }

    render() {
        const { tab, searchBox, searchData, isModerator, isInvited,callStatus, totalStatus, showEmoji, email, __invitedNum, members, clicked,email_list,member_list,toggle_reactions } = this.state;
        const {fireGroupParticipants,activate_guest_share_screen , _participants, extension_list, _visible, _knockingList, restricted,additional_moderator,tracks,is_recording_on} = this.props; 
        let additionalModerator = additional_moderator && additional_moderator.includes(APP.conference.getMyUserId()) ? true : false 
        this.validator.purgeFields();
        this.emailvalidator.purgeFields(); 
        return ( 
            <div
                className="modal fade MyModal invite-modal"
                id="InviteModal"
                tabIndex="-1"
                role="dialog"
                ariaLabelledby="InviteModalLabel"
                ariaHidden="true"
            >
                <div className="modal-dialog inviter-screen" role="document">
                    <div className="modal-content">
                        <div className={`modal-body invite-modal-body-outer ${_visible && (isModerator || additionalModerator) && _knockingList.length > 0 ? "lobby-list" : ""}`}>
                            <div className="invite-modal-body-inner">
                                <button
                                    type="button"
                                    className="close"
                                    onClick={() => $("#InviteModal").modal("hide")}
                                >
                                    <span aria-hidden="true">
                                        <img src="public/assets/images/invite-cross.svg" alt="1" />
                                    </span>
                                </button>
                                <div className="invite-modal-tabs">
                                    <ul className="nav nav-tabs invite-tab-list" id="myTab" role="tablist">
                                        <li className="nav-item" style={{ width: "100%" }}>
                                            <a href={void 0} onClick={() => this.setState({ tab: "home" })} className={`nav-link ${tab === "home" ? "active" : ""}`}>{`Participant (${_participants?.length})`}</a>
                                        </li>  
                                    </ul>
                                    <div className="tab-content" id="myTabContent">
                                        {tab === "home" && <div className="tab-pane show">
                                            {_visible &&  (isModerator || additionalModerator) && <div className="pause-room-section"> 
                                                {_knockingList.map((value, key) => {
                                                    return (
                                                        <div className="pause-room-list-scroll">
                                                            <div className="pause-room-user" key={`joinee${key}`}>
                                                                <span className="pause-room-left">
                                                                    <span className="pause-profo-img">
                                                                        <Avatar
                                                                            displayName={value.name}
                                                                            size={48}
                                                                            testId='knockingParticipant.avatar'
                                                                            url={value.profile_picture}
                                                                        />
                                                                    </span>
                                                                    <h4>{value.name}</h4>
                                                                </span>
                                                                <span className="pause-room-right">
                                                                    <a href={void 0} className="pause-admit-btn" onClick={() => this.SendApproval(value.email, true)}>Admit</a>
                                                                    <a href={void 0} className="pause-admit-btn ml-2" onClick={() => this.SendApproval(value.email, false)}>Reject</a>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>} 
                                            {(isModerator || additionalModerator) && 
                                            <div className="invite-modal-participant-tool">
                                                <a 
                                                    href={void 0} 
                                                    onClick={() => this.setState({ searchBox: !searchBox, searchData: "", isInvited: false })}
                                                >
                                                    <img src="public/assets/images/invite-search.svg" alt="1" />
                                                </a>
                                                <a 
                                                    href={void 0} 
                                                    onClick={() => this.setState({ isInvited: true, inviteType: "member" })}
                                                >
                                                    <img src="public/assets/images/invite-add-p.svg" alt="1" />
                                                </a>
                                                <a 
                                                    href={void 0} 
                                                    onClick={this.LockUnlockMeet}
                                                >
                                                    <img src={`public/assets/images/${restricted ? "invite-lock" : "invite-ulock"}.svg`} alt="1" />
                                                </a>
                                                <a 
                                                    href={void 0} 
                                                    onClick={() => SendCommandOnce("audio-mute-all", true)}
                                                >
                                                    <img src="public/assets/images/invite-unmute.svg" alt="1" />
                                                </a>
                                                <a 
                                                    href={void 0} 
                                                    onClick={this.onToggleChat}
                                                >
                                                    <img src="public/assets/images/invite-chat.svg" alt="1" />
                                                </a>
                                                <a href={void 0}>
                                                    <img src="public/assets/images/invite-copy.svg" alt="1" />
                                                </a>
                                                <a 
                                                    className={`${toggle_reactions?"smile_active":""}`}
                                                    href={void 0} 
                                                    onClick={this.toggleReactionsMenu}
                                                >
                                                    <img src="public/assets/images/invite-smile.svg" alt="1" />
                                                    <div className="smile_box" >
                                                        { this._getReactionButtons() } 
                                                    </div>
                                                </a>
                                            </div>} 
                                            {(isModerator || additionalModerator) &&  searchBox && <div id="search-box" className="collapse show search-collapse ">
                                                <div className="card card-body">
                                                    <input className="form-control" name="searchData" value={searchData} type="text" placeholder="Search" onChange={e => this.setState({ searchData: e.target.value })} />
                                                </div>
                                            </div>}
                                            {!isInvited && <ul className="invite-md-participant-list">
                                                {_participants && _participants.map((value, key) => {


                                                    if (searchData && !(value.name.toLowerCase()).includes(searchData.toLowerCase())) {
                                                        return null;
                                                    } 
                                                    let access = fireGroupParticipants?.[value.id]?.owner ? "Host" :  (!fireGroupParticipants?.[value.id]?.owner && fireGroupParticipants?.[value.id]?.type === "coordinator") ? "Moderator" : (!fireGroupParticipants?.[value.id]?.owner && fireGroupParticipants?.[value.id]?.type === "member")  ? "Member" : (!fireGroupParticipants?.[value.id]?.owner && fireGroupParticipants?.[value.id]?.type === "guest") ? "Guest" : "Guest"
                                                    const videoTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.VIDEO, value.id);  
                                                    const audioTrack = getTrackByMediaTypeAndParticipant(tracks, MEDIA_TYPE.AUDIO, value.id);  
                                                    console.log("_participants/access",_participants,access)

                                                    return (
                                                        <li key={`values${key}`}>
                                                            <span className="invite-participant-img-side">
                                                                <div className="invite-profile-img"> 
                                                                    <Avatar
                                                                        displayName={value.name}
                                                                        size={48}
                                                                        testId='participant.avatar'
                                                                        url={value.avatarURL}
                                                                    /> 
                                                                </div>
                                                                <div className="invite-profile-text">
                                                                    <h3>{value.name}</h3>
                                                                    <p>{`(${value.local ? "You, " : ""}${access === "Moderator" ? "Host" : access})`}</p>
                                                                </div>
                                                                {(access === "Host" || access === "Moderator" )  && 
                                                                    <span className="invite-crown">
                                                                        <img src="public/assets/images/invite-crown.svg" alt="1" />
                                                                    </span>
                                                                }
                                                            </span>
                                                            <span className="participant-icons-side dropdown">
                                                                {value.raisedHand && 
                                                                    <a 
                                                                        href={void 0} 
                                                                        onClick={() => this.onRaiseHand(value.id)}
                                                                    >
                                                                        <img src="public/assets/images/invite-hand.svg"  alt="1" />
                                                                    </a>
                                                                }
                                                                <a href={void 0}> <ConnectionIndicator /> </a>
                                                                {is_recording_on && is_recording_on.includes(value.id) && 
                                                                    <a href={void 0}>
                                                                        <img src={`public/assets/images/recording-icon.svg`} alt="1" />
                                                                    </a> 
                                                                } 
                                                                {videoTrack?.videoType === 'desktop' && 
                                                                    <a href={void 0}>
                                                                        <img src={`public/assets/images/screen-share-icon.svg`} alt="1" />
                                                                    </a> 
                                                                } 
                                                                <a href={void 0}>
                                                                    <img src={`public/assets/images/${audioTrack?.muted ? "mic-off.svg" : "mic-on.svg"}`} alt="1" />
                                                                </a>
                                                                <a href={void 0}>
                                                                    <img src={`public/assets/images/${videoTrack?.muted ? "video-off.svg" : "cloud/ant-design_video-camera-outlined.png"}`} alt="1" />
                                                                </a>
                                                                {(isModerator||additionalModerator) && access!=="Host" &&access!=="Moderator"  && APP.conference.getMyUserId() !== value.id &&  
                                                                    <>
                                                                        <a href={void 0} id="dropdownMenuButton" data-toggle="dropdown" aria-has-popup="true" aria-expanded="false">
                                                                            <i className="fa fa-ellipsis-v" />
                                                                        </a>
                                                                        <div className="dropdown-menu"                    aria-labelledby="dropdownMenuButton">
                                                                            <a 
                                                                                className="dropdown-item" 
                                                                                href={void 0} 
                                                                                onClickCapture={()=>this.grantModeratorHandler(value)} 
                                                                            >
                                                                                Host
                                                                            </a> 
                                                                            <a 
                                                                                className="dropdown-item" href={void 0}  
                                                                                onClick={() => SendCommandOnce("mute-audio-user", value.id)}
                                                                            >
                                                                                Mute
                                                                            </a>
                                                                            <a 
                                                                                className="dropdown-item" 
                                                                                href={void 0} 
                                                                                onClick={() => SendCommandOnce("mute-video-user", value.id)}
                                                                            >
                                                                                Camera
                                                                                </a> 
                                                                            {videoTrack?.videoType !== 'desktop' && 
                                                                            <a 
                                                                                className="dropdown-item" 
                                                                                href={void 0}  
                                                                                onClick={()=>
                                                                                    SendCommandOnce("screen-share", JSON.stringify({
                                                                                        id:value.id,
                                                                                        isEnabled:activate_guest_share_screen && activate_guest_share_screen.includes(value.id) ? false : true})
                                                                                    )
                                                                                }
                                                                            >
                                                                                {activate_guest_share_screen && activate_guest_share_screen.includes(value.id) ? "Stop Sharing" :  "Share Screen"} 
                                                                            </a>}
                                                                        </div>
                                                                    </> 
                                                                }
                                                            </span>
                                                        </li>
                                                    ) 
                                                })}
                                            </ul>}
                                            {isInvited && <> 
                                                <div className="search-email-remind">
                                                    <h3>
                                                        Invite and Remind
                                                        <button type="button" className="close" onClick={()=>this.setState({isInvited:false})}>
                                                            <span aria-hidden="true"><img src="public/assets/images/invite-cross.svg" alt="1" /></span>
                                                        </button>
                                                    </h3>
                                                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                                                        <li className="nav-item" role="presentation">
                                                            <a className="nav-link active" id="search-team-tab" data-toggle="tab" href="#search-team" role="tab" aria-controls="search-team" aria-selected="true">
                                                                <span className="bg-pos-ico search-team"></span>
                                                                <span className="d-block">Search Team</span>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <a className="nav-link" id="email-meet-tab" data-toggle="tab" href="#eamil-meet" role="tab" aria-controls="eamil-meet" aria-selected="false">
                                                                <span className="bg-pos-ico invite-email"></span>
                                                                <span className="d-block">Email</span>
                                                            </a>
                                                        </li>
                                                        <li className="nav-item" role="presentation">
                                                            <a className="nav-link" id="remind-meet-tab" data-toggle="tab" href="#remind-meet" role="tab" aria-controls="remind-meet" aria-selected="false">
                                                                <span className="bg-pos-ico invite-remind"></span>
                                                                <span className="d-block">Remind</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                    <div className="tab-content" id="myTabContent">
                                                        <div className="tab-pane fade show active" id="search-team" role="tabpanel" aria-labelledby="search-team-tab">
                                                            <h4>Select your team member to join your meeting</h4>
                                                            <div className="search-team-check-list">
                                                                {extension_list && extension_list?.length > 0 ? extension_list.map((values, keys) => {
                                                                    console.log("extension_list_value",values)
                                                                    let number = values.phone.replace("+", "");
                                                                    return (
                                                                        <div className="form-check" key={`extensions_${keys}`}>
                                                                            <input 
                                                                                className="form-check-input" 
                                                                                type="checkbox" 
                                                                                checked={__invitedNum.includes(number) ? "checked" : ""} 
                                                                                onChange={e => this.setState({ 
                                                                                    __invitedNum: e.target.checked ? [...__invitedNum, number] : __invitedNum.filter(val => val !== number) })} 
                                                                                id={`defaultCheck${keys}`} 
                                                                                disabled={callStatus[number]} 
                                                                            />
                                                                            <label 
                                                                                className="form-check-label invite-remind-list-label" 
                                                                                for={`defaultCheck${keys}`}
                                                                            >
                                                                            <Avatar
                                                                                displayName={`${values.firstname} ${values.lastname}`}
                                                                                size={25}
                                                                                testId='User.avatar'
                                                                                url={values.profile_picture}
                                                                            />
                                                                            <div className="invite-remind-name-div">
                                                                                <span className="Inviter-name">
                                                                                    {`${values.firstname} ${values.lastname}`}
                                                                                </span>
                                                                                <span className={totalStatus[values.uniquecode]?"user-online text-success":"user-offline text-danger"}>
                                                                                    {totalStatus[values.uniquecode] ? "Online" : "Offline"}
                                                                                </span> 
                                                                            </div>
                                                                            </label>
                                                                        </div>
                                                                    )
                                                                }) : <span>No Record Found</span>}
                                                            </div>
                                                            <div className="invite-team-member-div">
                                                                <a href={void 0} className="invite-team-member-link" onClick={() => __invitedNum.length > 0 ? this.InviteMember(__invitedNum) : alert("No Member is selected")}>Invite Team Member</a>
                                                            </div>
                                                        </div>
                                                        <div className="tab-pane eamil-meet fade" id="eamil-meet" role="tabpanel" aria-labelledby="email-meet-tab">
                                                            <div className="invite-eamil-textarea">
                                                                <label for="exampleFormControlTextarea1">Invitees:</label>
                                                                <Paper component="ul" className="email-input-ul">
                                                                    {members && members.map((data) => {
                                                                        let icon;
                                                                        return (
                                                                            <li key={data.key}>
                                                                                <Chip icon={icon} label={data.label} onDelete={this.handleDelete(data)} className={"chip-org"} />
                                                                            </li>
                                                                        );
                                                                    })}
                                                                    <input className="form-control" name="email" value={email} placeholder="Type email" onKeyDown={this.handleKeyDown} onChange={this.handleChange} onBlur={()=>this.handleKeyDown({key:"Enter",preventDefault:()=>{return null}})} />
                                                                </Paper>
                                                                {this.emailvalidator.message("Email", email, 'email')}
                                                                {this.validator.message("Members", members, 'required')}
                                                                <p>Seperate addresses with commas or semicolons.</p>
                                                            </div>
                                                            <div className="invite-team-member-div">
                                                                <h6>Invite by using your email application</h6>
                                                                <a className="invite-team-member-link" onClick={this.SendEmail}>{`${clicked ? "Please Wait..." : "Send"}`}</a>
                                                            </div>
                                                        </div>
                                                        <div className="tab-pane remind-meet fade" id="remind-meet" role="tabpanel" aria-labelledby="remind-meet-tab">
                                                            <p>The following guests have not joined your meeting.
                                                                Select the guests you wish to remind</p>
                                                            <div className="search-team-check-list">
                                                                {email_list && email_list?.length > 0 ?  email_list.map((values,keys)=>{
                                                                    return (
                                                                        <div className="form-check" key={`data${keys}`}>
                                                                            <input 
                                                                                className="form-check-input" 
                                                                                type="checkbox"  
                                                                                onChange={e => this.setState({
                                                                                    member_list: e.target.checked ? [...member_list, values.email] : member_list.filter(val => val !== values.email) })
                                                                                }  
                                                                                id={`reminder_${keys}`} 
                                                                                checked={member_list.includes(values.email)} 
                                                                            />
                                                                            <label 
                                                                                className="form-check-label" 
                                                                                for={`reminder_${keys}`}
                                                                            >
                                                                                {values.email}
                                                                            </label>
                                                                    </div>
                                                                    )                                                                        
                                                                }) : <div
                                                                className="form-check"
                                                               
                                                            >
                                                                <label
                                                                    className="form-check-label"
                                                                >
                                                                    No participant for remind <br />
                                                                    please send mail to it for reminding
                                                                </label>
                                                            </div>}
                                                                
                                                            </div>
                                                            <h4>Send reminders with your local email</h4>
                                                            <div className="invite-team-member-div">
                                                                <a className="invite-team-member-link" onClick={this.RemindEmail}>{clicked?"Please Wait":"Send Reminder"}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                            }
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        );
    }
} 


const _mapStateToProps = (state) => { 
    let _participants = _getAllParticipants()
        _participants = _participants && _participants?.filter((value) => value.name !== "Recorder");
    return {
        _visible: state["features/nxatel"]._visible ?? false,
        _knockingList: state["features/nxatel"].knockingList ?? [],
        _meetDetail: state["features/nxatel_meet"].meeting_details, 
        _participants,
        tracks: state["features/base/tracks"],
        extension_list: state["features/nxatel_meet"].extension_list, 
        _roomName: getConferenceNameForTitle(state),  
        activate_guest_share_screen : state["features/nxatel"].activate_guest_share_screen,
        additional_moderator:  state["features/nxatel"].additional_moderator,
        is_recording_on : state["features/nxatel"].is_recording_on, 
    };
};
export default connect(_mapStateToProps)(InviteMore);
